import React, { useState } from 'react'
import { PAYMENTMODE, targetBankCode, targetPayInToBank } from '../../../constants'
import NumberFormat from 'react-number-format'
import dayjs from 'dayjs'
import { PayInBank } from '../../../component/entryForm/bankAccount'
import { WatDatePicker } from '../../../component/datePicker'
import errorAlert from '../../../assets/images/error-alert.svg'
import { useSelector, useDispatch } from 'react-redux'
import { RootReducers } from '../../../redux/reducers'
import { getPaymentDetailValueByObj, getPaymentDetailObj } from '../../EntryForm/helper'
import * as paymentDetailAction from '../../../redux/actions/paymentDetail.detail.action'
import { getBankName } from '../../../helpers/texthelper'

interface IQRCodeProps {
  label: string
  paymentDetail?: any
  documentId: number
  setPaymentDetailFormValue: (obj: any) => void
}

const allUsingKeys = {
  paymentAmount: 'paymentAmount',
  payInDate: 'payInDate',
  bankCode: 'bankCode',
  accountNo: 'accountNo',
  remarkMoneyType: 'remarkMoneyType'
}

export const QRCode: React.VFC<IQRCodeProps> = ({
  label,
  paymentDetail,
  documentId,
  setPaymentDetailFormValue
}) => {
  const dispatch = useDispatch()
  const loginState = useSelector((state: RootReducers) => state.loginReducer)
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
  const [formData, setFormData] = useState({
    [allUsingKeys.paymentAmount]: getPaymentDetailValueByObj(
      paymentDetail,
      allUsingKeys.paymentAmount
    ),
    [allUsingKeys.payInDate]: getPaymentDetailValueByObj(paymentDetail, allUsingKeys.payInDate),
    [allUsingKeys.bankCode]: getPaymentDetailValueByObj(paymentDetail, allUsingKeys.bankCode),
    [allUsingKeys.accountNo]: getPaymentDetailValueByObj(paymentDetail, allUsingKeys.accountNo),
    [allUsingKeys.remarkMoneyType]: getPaymentDetailValueByObj(
      paymentDetail,
      allUsingKeys.remarkMoneyType
    )
  })
  const [formErrors, setFormErrors] = useState<any>({})

  const handleEnterKey = (e: React.KeyboardEvent<HTMLInputElement> | any) => {
    if (e.key === 'Enter') {
      e.preventDefault()
    }
  }

  const onChangePayInBank = (bankAccountModelView: any) => {
    const changedFieldName = bankAccountModelView?.target?.name
    const updatedValue = bankAccountModelView?.target?.value
    if (changedFieldName === targetPayInToBank) {
      setFormData({
        ...formData,
        ...{
          [allUsingKeys.bankCode]: '',
          [allUsingKeys.accountNo]: ''
        }
      })
    } else if (changedFieldName === targetBankCode) {
      setFormData({
        ...formData,
        ...{
          [allUsingKeys.bankCode]: updatedValue,
          [allUsingKeys.accountNo]: ''
        }
      })
    } else {
      setFormData({
        ...formData,
        ...{
          [allUsingKeys.accountNo]: updatedValue
        }
      })
    }
  }

  const onChangeData = (value: any, fieldName: string) => {
    setFormData({
      ...formData,
      [fieldName]: value
    })
  }

  const onClickSubmit = () => {
    const allErrors = validateAllValue()
    const keysArray = Object.keys(allErrors)
    const count = keysArray?.length
    if (count > 0) {
      return
    }
    setIsSubmitting(true)
    const savedPaymentDetail = getPaymentDetailObj(paymentDetail, formData)
    dispatch(paymentDetailAction.updatePaymentDetail(documentId, savedPaymentDetail))
    if (setPaymentDetailFormValue) {
      setPaymentDetailFormValue(savedPaymentDetail)
    }

    setIsSubmitting(false)
  }

  const validateAllValue = () => {
    const exceptionalFields = {
      [allUsingKeys.remarkMoneyType]: true
    }
    const allErrors = {}

    Object.keys(formData).forEach(key => {
      const value = formData[key]
      if (!value && !exceptionalFields[key]) {
        Object.assign(allErrors, { [key]: true })
      }
    })
    setFormErrors(allErrors)
    return allErrors
  }

  return (
    <div className="container-info">
      <div className="form-content">
        <div className="required">
          <label className="group-label-input">
            <span className="amount-text">Amount</span>
            <NumberFormat
              onKeyPress={(e: any) => handleEnterKey(e)}
              allowNegative={false}
              thousandSeparator={true}
              prefix=""
              decimalScale={2}
              name={allUsingKeys.paymentAmount}
              className={`amount-input`}
              inputMode="decimal"
              autoComplete="off"
              disabled={true}
              onChange={(e: any) => {
                onChangeData(e?.target?.value, allUsingKeys.paymentAmount)
                if ('paymentAmount' in formErrors && formErrors['paymentAmount']) {
                  setFormErrors({
                    ...formErrors,
                    paymentAmount: false
                  })
                }
              }}
              value={formData.paymentAmount}
            />
            {formErrors?.paymentAmount && (
              <div className="error-text-validate">
                <img src={errorAlert} alt="ErrorAlert" />
                กรุณากรอกข้อมูล
              </div>
            )}
          </label>
        </div>

        {/* <div className="required">
          <label className="group-label-input">
            <PayInBank
              paymentMode={PAYMENTMODE.QRCODE}
              branchCode={loginState.account?.agentInfo.branchCode as string}
              onSelect={(bankAccountModelView: any) => {
                console.log('bankAccountModelView', bankAccountModelView)
                onChangePayInBank(bankAccountModelView)
              }}
              defaultPayInBankType={formData.payInToBank}
              defaultBankCode={formData.cheque_BankCode}
              defaultAccount={formData.accountNo}
              isRequireBank={formErrors?.cheque_BankCode}
              isRequireAccountNo={formErrors?.accountNo}
            ></PayInBank>
          </label>
        </div> */}

        <div className="required">
          <span className="amount-text">รายละเอียดธนาคาร </span>
          <input
            className={`amount-input`}
            type="text"
            name={allUsingKeys.bankCode}
            autoComplete="off"
            onKeyPress={e => handleEnterKey(e)}
            disabled={true}
            onChange={e => onChangeData(e?.target?.value, allUsingKeys.bankCode)}
            value={getBankName(formData.bankCode)}
          />
        </div>

        <div className="required">
          <span className="amount-text">เลขที่บัญชี</span>
          <input
            className={`amount-input`}
            type="text"
            name={allUsingKeys.accountNo}
            autoComplete="off"
            disabled={true}
            onKeyPress={e => handleEnterKey(e)}
            onChange={e => onChangeData(e?.target?.value, allUsingKeys.accountNo)}
            value={formData.accountNo}
          />
        </div>

        <div className="required">
          <span className="amount-text">วันที่ฝาก</span>
          <WatDatePicker
            className={`amount-input`}
            name={allUsingKeys.payInDate}
            onChange={(christDate: any, buddhistDate: any) => {
              onChangeData(christDate, allUsingKeys.payInDate)
              if ('payInDate' in formErrors && formErrors['payInDate']) {
                setFormErrors({
                  ...formErrors,
                  payInDate: false
                })
              }
            }}
            dateFormat={'yyyy-MM-dd'}
            displayFormat={'DD/MM/YYYY'}
            clearable={false}
            minDate={dayjs().add(-2, 'year')}
            maxDate={dayjs().add(5, 'year')}
            disabled={true}
            readOnly={true}
            yearBoundary={99}
            inputStyle={null}
            value={formData.payInDate}
          />
          {formErrors?.payIndate && (
            <div className="error-text-validate">
              <img src={errorAlert} alt="ErrorAlert" />
              กรุณากรอกข้อมูล
            </div>
          )}
        </div>

        <div>
          <span className="amount-text">หมายเหตุ</span>
          <input
            className={`amount-input`}
            type="text"
            name={allUsingKeys.remarkMoneyType}
            autoComplete="off"
            onKeyPress={e => handleEnterKey(e)}
            onChange={e => onChangeData(e?.target?.value, allUsingKeys.remarkMoneyType)}
            value={formData.remarkMoneyType}
          />
        </div>
        <div className="button-container">
          <button
            className="cancel-button"
            onClick={() => {
              setPaymentDetailFormValue('')
            }}
          >
            ยกเลิก
          </button>
          <button className="confirm-paid-button" onClick={onClickSubmit} disabled={isSubmitting}>
            {isSubmitting ? 'กำลังบันทึกข้อมูล...' : 'ตกลง'}
          </button>
        </div>
      </div>
    </div>
  )
}
